import { registerPlugin } from '@capacitor/core';
const IntentLauncher = registerPlugin('IntentLauncher', {
    web: () => import('./web').then((m) => new m.IntentLauncherWeb()),
});
export * from './definitions';
export { IntentLauncher };
//# sourceMappingURL=index.js.map